import { jsPDF } from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import ReportBaseService from "../../../servico/ReportBaseService";
import ParamService from "../../../servico/ParametroServico";


class DashboardReportPdf {

  async Execute() {
    await ParamService.GetReport()
      .then(async (result) => {
        await this.GenerateReport(result.data);
      })
      .catch((erro) => {
        return;
      });
  }

  async GenerateReport(param) {
    // let param = await this.GetParam();
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4"
    });

    const chartsPageOne = [
      document.getElementById("cardsCount"),
      document.getElementById("chartTopTree"),
      document.getElementById("chartColumnOrigin"),
      document.getElementById("chartPieHeigthClass"),
      document.getElementById("chartPieOrigin"),
    ];

    const chartsPageTwo = [
      document.getElementById("chartGaau")
    ];

    await ReportBaseService.SetHeaderAndFooter(doc, param);

    let imagens = await this.CaptureImagens(chartsPageOne);
    await this.AddImagesToPDF(doc, imagens);

    doc.addPage();
    await ReportBaseService.SetHeaderAndFooter(doc, param);

    let imagensTwo = await this.CaptureImagens(chartsPageTwo);
    doc.addImage(imagensTwo[0], "PNG", 5, 35, 200, 60);

    doc.save("dashboard.pdf");
  }

  async AddImagesToPDF(doc, imagesData) {
    for (let i = 0; i < imagesData.length; i++) {
      const imgWidth = doc.internal.pageSize.getWidth();

      switch (i) {
        case 0:
          doc.addImage(imagesData[i], "PNG", 5, 35, 200, 20);
          break;
        case 1:
          doc.addImage(imagesData[i], "PNG", 5, 55, 200, 60);
          break;
        case 2:
          doc.addImage(imagesData[i], "PNG", 5, 115, 200, 60);
          break;
        case 3:
          doc.addImage(imagesData[i], "PNG", 10, 175, 100, 60);
          break;
        case 4:
          doc.addImage(imagesData[i], "PNG", 100, 175, 100, 60);
          break;
        default:
          break;
      }
    }
  }

  async CaptureImagens(elements) {
    let imagesData = [];
    for (const element of elements) {
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL("image/png");
      imagesData.push(imgData);
    }
    return imagesData;
  }

}

export default new DashboardReportPdf();
